export const ESTADOS_CENTRO_CONCILIACION = 263 //212;
export const TIPOS_CENTRO_CONCILIACION =  264 //1212;
export const TIPOS_INFORMES_CENTRO = 266 // 2213
